import React, { useEffect, useRef } from 'react'

const ANCHO = 600
const ALTO = 220
const GROSOR = 3

/**
 * Recuadro para firmar con mouse, dedo o lápiz. Guarda la firma como trazos
 * (listas de puntos en px del recuadro), no como imagen, para poder doblarla
 * sobre las crestas de la huella sin perder calidad.
 * `onCambio(trazos)` se llama al terminar cada trazo.
 */
const PadFirma = ({ trazos, onCambio }) => {
  const canvasRef = useRef(null)
  const actualRef = useRef(null)

  // Redibuja todo (al deshacer, limpiar o montar).
  useEffect(() => {
    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, ANCHO, ALTO)
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.lineWidth = GROSOR
    ctx.strokeStyle = '#1f2328'
    trazos.forEach((trazo) => {
      ctx.beginPath()
      trazo.forEach((p, i) => (i ? ctx.lineTo(p.x, p.y) : ctx.moveTo(p.x, p.y)))
      if (trazo.length === 1) ctx.lineTo(trazo[0].x + 0.1, trazo[0].y)
      ctx.stroke()
    })
  }, [trazos])

  const punto = (e) => {
    const r = canvasRef.current.getBoundingClientRect()
    return { x: ((e.clientX - r.left) / r.width) * ANCHO, y: ((e.clientY - r.top) / r.height) * ALTO }
  }

  const iniciar = (e) => {
    if (e.button !== 0) return
    e.preventDefault()
    canvasRef.current.setPointerCapture(e.pointerId)
    actualRef.current = [punto(e)]
  }

  const mover = (e) => {
    const trazo = actualRef.current
    if (!trazo) return
    const p = punto(e)
    const ultimo = trazo[trazo.length - 1]
    if (Math.hypot(p.x - ultimo.x, p.y - ultimo.y) < 1) return
    trazo.push(p)
    const ctx = canvasRef.current.getContext('2d')
    ctx.lineCap = 'round'
    ctx.lineWidth = GROSOR
    ctx.strokeStyle = '#1f2328'
    ctx.beginPath()
    ctx.moveTo(ultimo.x, ultimo.y)
    ctx.lineTo(p.x, p.y)
    ctx.stroke()
  }

  const terminar = () => {
    const trazo = actualRef.current
    actualRef.current = null
    if (trazo?.length) onCambio([...trazos, trazo])
  }

  return (
    <div className="huella-pad">
      <canvas
        ref={canvasRef}
        width={ANCHO}
        height={ALTO}
        onPointerDown={iniciar}
        onPointerMove={mover}
        onPointerUp={terminar}
        onPointerCancel={terminar}
      />
      {!trazos.length && <span className="huella-pad__ayuda">Firma aquí</span>}
      <span className="huella-pad__linea" />
    </div>
  )
}

export default PadFirma
